// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"51":"NewsList","471":"activity","549":"ArticleDetails","664":"notice","732":"News","969":"More"}[chunkId] || chunkId) + "-legacy." + {"51":"c4cddb4a","395":"aeef9f44","471":"2909d3fa","549":"66938df4","574":"8fa7f6fc","664":"2b461832","732":"05e5e325","969":"30461b29"}[chunkId] + ".js";
};